import { Injectable } from '@angular/core';
import { UserService } from 'src/app/services/user.service';

interface PageViewEventProps {
  event: string;
  page: {
    environment: string,
    platform: string
  };
}

interface UserEventProps {
  user: {
    'user-cpf'?: string;
    'user-email'?: string;
    'user-cnpj'?: string;
    'client-type': string;
    'account-responsible': string[];
    'id-empresa': string;
    'id-colaborador': string;
    'type-business': string;
  };
  login: {
    'user-is-logged': boolean;
    'login-type'?: string;
  };
}

interface InteractionProps {
  'event': string;
  'event-category': string;
  'event-action': string;
  'event-label': string;
}

@Injectable()
export class GTMService {

  user;
  company;

  constructor(
    private userService: UserService
  ) {
    this.user = userService.getLoggedUser();
    this.company = this.userService.getLoggedAccount();

    this.setUserProperties();
  }

  setUserProperties() {
    if (this.user && this.company) {
      const { id, companyId } = this.user;
      const { customer_profile, accountManagerIds, type } = this.company;

      const userEvent: UserEventProps = {
        user: {
          'client-type': customer_profile || '',
          'account-responsible': accountManagerIds || [],
          'type-business': type || '',
          'id-empresa': companyId || '',
          'id-colaborador': id || '',
        },
        login: {
          'user-is-logged': !!this.user,
        }
      };

      (window as any).dataLayer.push(userEvent);
    }
  }

  setPageView() {
    const pageEvent: PageViewEventProps = {
      event: 'pageview',
      page: {
        environment: 'userportal',
        platform: 'web-responsivo'
      }
    };

    return this.sendEvent(pageEvent);
  }

  interaction(category: string, action: string, label: string) {
    const interactionEvent: InteractionProps = {
      event: 'interaction',
      'event-category': category,
      'event-action': action,
      'event-label': label
    };

    this.sendEvent(interactionEvent);
  }

  sendEvent(event: any) {
    const windowObj = (window as any);

    if (windowObj && 'dataLayer' in windowObj) {
      this.setUserProperties();
      windowObj.dataLayer.push(event);
    }

    return event;
  }

  error = (action: string, data: any, extraInfo: any) => {
    const event = {
      event: 'application_error',
      application_error: {
        action,
        data: JSON.stringify(data),
        extra_info: JSON.stringify(extraInfo),
        app: 'admin'
      },
    };

    this.sendEvent(event);
  }
}
